import * as actionTypes from '../action-types'

const initialState = {
    myloading: false
};

export default function loading(state = initialState, action = {}) {
    console.log(action)
    switch (action.type) {
        case actionTypes.UPDATALOADING:
            return Object.assign({}, state, {
                myloading: action.flag || false
            });
        default:
            return state
    }
}